function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 247 121"
}, props), React.createElement("path", {
  d: "M55 8.5a1 1 0 011-1h169.849a1 1 0 011 1v95.921a1 1 0 01-1 1H56a1 1 0 01-1-1V8.5z",
  fill: "#fff",
  stroke: "#B8B7B7",
  strokeWidth: "8"
}), React.createElement("path", {
  d: "M11.353 3.92c.073-.748 1.134-.823 1.312-.093a.667.667 0 01-.017.374l-.266.773c-.771 2.241.894 4.576 3.265 4.576h99.242l95.565 2.808a7 7 0 016.792 6.807l2.56 94.646a7.001 7.001 0 01-6.998 7.189H7.712c-4.133 0-7.367-3.562-6.968-7.676L11.354 3.92z",
  fill: "#fff"
}), React.createElement("path", {
  d: "M206.502 94.947a4.34 4.34 0 016.429-5.833l5.838 6.416c3.302 3.63 8.983 3.717 12.395.191l6.236-6.445a4.173 4.173 0 016.238 5.534l-5.166 6.358-8.011 8.315a7.5 7.5 0 01-10.963-.172l-12.996-14.364z",
  fill: "#B8B7B7",
  stroke: "#B8B7B7"
})));